import { render } from "./TutorialDamand.vue?vue&type=template&id=bf2d9e18"
import script from "./TutorialDamand.vue?vue&type=script&lang=js"
export * from "./TutorialDamand.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__